import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
